import {Component, ContainerEditor} from 'substance'
import {Event} from '../../../../../lib/constants/Event'

class BodyComponent extends Component {
    constructor(...args) {
        super(...args)
        this._onUpdate = this._onUpdate.bind(this)
    }

    getInitialState() {
        return {
            textDirection: this.context.editorSession.getTextDirection(),
            showTextStyles: this.getTestStyleSetting()
        }
    }

    didMount() {
        this.context.editorSession.onUpdate(this._onUpdate)

        this.context.api.events.on('BodyComponent', Event.SETTINGS_CHANGED, (ev) => {
            if (ev.data.key === 'se.infomaker.switch-text-type.settings.visible') {
                this.extendState({showTextStyles: this.getTestStyleSetting()})
            }
        })
    }

    dispose() {
        this.context.editorSession.off(this)
        this.context.api.events.off('BodyComponent', Event.SETTINGS_CHANGED)
    }

    /**
     * @param {EditorSession} change
     * @private
     */
    _onUpdate(change) {
        if (change.hasLanguageChanged()) {
            setImmediate(() => {
                const textDirection = this.context.editorSession.getTextDirection()
                if (textDirection !== this.state.textDirection) {
                    this.extendState({
                        textDirection
                    })
                }
            })
        }
    }

    render($$) {
        const {node, disabled, commands, textTypes, spellcheck} = this.props

        const classNames = `sc-body ${(this.state.showTextStyles ? ' se-text-style-visible' : '')}`

        return $$('div')
            .ref('dwc-body-wrapper')
            .addClass(classNames)
            .attr('id', 'dwc-body-wrapper')
            .addClass(`sc-dir-${this.state.textDirection}`)
            .append(
                $$(ContainerEditor, {
                    disabled,
                    node,
                    commands,
                    textTypes,
                    spellcheck
                })
                    .ref('dwc-body-editor')
                    .addClass('dwc-body-editor')
            )
    }

    getTestStyleSetting() {
        return this.context.api.settings.get(
            'se.infomaker.switch-text-type.settings',
            'visible',
            this.context.configurator.getWriterConfigValue('showTextStyles', false))
    }
}

export {BodyComponent}
